<template>

  <!-- Contact Area -->
  <div class="contact-us-area section-padding-xs">

    <!-- Contact Us Info -->
    <div class="container">
      <div class="row">

        <div class="col-lg-7">
          <div class="commentbox">
            <h5>LEAVE US A MESSAGE</h5>
            <p>Please provide the following information and the Client Services will answer your inquiry as soon as possible.</p>

            <form ref="refForm" id="contactForm" onsubmit="return false">

              <div class="form-group">
                <label for="memberNickName">Name *</label>
                <input type="text" class="form-control is-invalid" required v-model="review.memberNickName" id="memberNickName" aria-describedby="memberNickNameHelp" >
              </div>

              <div class="form-group">
                <label for="eMail">E-MAIL *</label>
                <input type="email" class="form-control is-invalid" required v-model="review.eMail" id="eMail" aria-describedby="eMailHelp" >
              </div>

              <div class="form-group">
                <label for="tel">Phone</label>
                <input type="tel" class="form-control"  v-model="review.tel" id="tel" aria-describedby="telHelp" >
              </div>
              <div class="form-group">
                <label for="productName">Subject *</label>
                <input type="text" class="form-control is-invalid"  v-model="review.productName" id="productName" >
              </div>

              <div class="form-group">
                <label for="content">Message</label>
                <textarea class="form-control" id="content"  v-model="review.content"  rows="3"></textarea>
              </div>

              <button class="sn-button sn-button-dark" type="submit"><span>Send</span></button>
            </form>
            <p class="form-message"></p>
            <div class="commentbox mt-5">

              <h5 class="font-weight-bold">CONTACT US</h5>
              <div class="row">
                <div class="col-7">
                  <p>If you would like to contact us, you can reach us at:</p>
                  <ul>
                    <li style="list-style:none; line-height:24px;">BUKI LEATHER LIMITED </li>
                    <li style="list-style:none; line-height:24px;">Main: <a href="tel:+008602089688862" style="color:#333333">0086 020 89688862</a></li>
                    <li style="list-style:none; line-height:24px;">Fax : <a href="tel:+008602089688863" style="color:#333333"> 0086 020 89688863</a></li>
                    <li style="list-style:none; line-height:24px;">Mob : <a href="tel:+008618122244504" style="color:#333333">0086 18122244504</a></li>
                    <li style="list-style:none; line-height:24px;">Email : <a href="mailto://customer@bukibags.com" style="color:#333333">customer@bukibags.com</a></li>
                  </ul>
                </div>

                <div class="col-5">
                  <h6 > Customercare Wechat:</h6>
                  <div class="about-image border-success text-center">
                    <img src="/img/wechat.png" alt="Customercare Wechat" style="width:70%;">
                  </div>
                </div>
              </div>

              <p class="form-message text-left">If you have any other questions or need to contact us for expedited orders, special requests, product recommendations, or any other reason, please don’t hesitate, we will gladly assist you!</p>
            </div>

          </div>
        </div>
        <div class="col-lg-5">
          <div class="about-image mt-0">
            <img src="/img/contact-img-2.jpg" alt="beautiful bags">
          </div>
          </div>
    <!--    <div class="col-lg-5">
          <div class="about-image mt-0">
            <img src="/img/contact-img-2.jpg" alt="beautiful bags">
          </div>
        </div>-->

      </div>

    </div>


    <message-tips  ref="rMessageTips"></message-tips>
  </div>
</template>

<script>
  const defaultValue = {
    star:5,
    content:'',
    eMail:'',
    memberNickName:'',
    productId:0,
    contentPath:'',
    productName:'',
    tel:''
  }
  import request from '@/utils/request'
  import messageTips from '@/components/MessageTips'


  export default {
    name: "contact-us",
    components:{messageTips},
    data(){
      return {
        review: Object.assign({}, defaultValue),
        datas:[],
        count: '',
        timer: null,
      }
    },
    mounted(){
      let _this = this
      let form = document.getElementById("contactForm");
      form.addEventListener("submit", function(event) {
        if (form.checkValidity() === true) {
          _this.submitReview()
        }
      }, false);
    },
    methods:{
      submitReview(){
        let _this = this
        _this.review.contentPath = window.location.href
        request({
          url:'/pms-comment/save',
          method:'POST',
          data:_this.review
        }).then(res=>{
        })

        _this.review = Object.assign({}, defaultValue)
        _this.$refs.rMessageTips.memberNickName = _this.review.memberNickName
        _this.$refs.rMessageTips.setTimer()

        return false
      }
  }

  }
</script>

<style scoped>

</style>
